const columns = [
    {
        field: "tmpId",
        type: "tmpId",
        sort: "asc",
        width: 150,
    },
    {
        field: "startDate",
        label: "Od",
        sort: "asc",
        width: 150,
    },
    {
        field: "endDate",
        label: "Do",
        sort: "asc",
        width: 150,
    },
    {
        name: 'priceList',
        label: 'Cennik',
        column: 1,
        type: 'custom',
        custom: function (column, row, navigate) {
            return row.priceList.name;
        }
    },
];

export default columns;
